<template>
  <v-btn
    class="lib-btn-simple"
    :to="to"
    :href="href"
    :small="small"
    text
    :color="color"
    :outlined="outlined"
  >
    <v-icon class="mr-2" v-if="icon">{{ icon }}</v-icon>
    <span :class="{ underline: underline }">{{ text }}</span>
    <v-icon right v-if="iconRight"> {{ iconRight }} </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "LibBtnSimple",
  props: {
    icon: {
      type: String,
      default: ""
    },
    iconRight: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#152d69"
    },
    fontWeight: {
      type: String,
      default: "400"
    },
    to: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.lib-btn-simple {
  text-decoration: none;
  text-transform: none;
  span.underline {
    text-decoration: underline;
    letter-spacing: normal !important;
  }
}
</style>
